import { render } from "./About.vue?vue&type=template&id=8197f156"
const script = {}

import exportComponent from "E:\\Proj\\Apps\\survey_app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__